import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function TicketConfirmation({ session, spot, lot, onClose }) {
  return (
    <div data-testid="checkin-confirmation" className="space-y-5 py-2 text-center">
      <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-400" />
      <div>
        <p className="text-sm uppercase tracking-[0.2em] text-slate-400">Checked in · confirmation</p>
        <p data-testid="checkin-ticket-number" className="mt-2 font-data text-3xl font-black tracking-wide text-[#d946ef]">
          {session.ticketNumber}
        </p>
      </div>
      <div className="rounded-lg border border-slate-800 bg-slate-950 p-4 text-left text-sm text-slate-300">
        <p>{lot?.name} · Spot #{spot?.spotNumber} · {session.tenancyType}</p>
        <p className="text-slate-400">
          {session.paymentStatus === "Paid" && session.paidUntil ? "Paid through " : "Expires "}
          <span data-testid="checkin-stay-end">{new Date(session.expiresAt).toLocaleString()}</span>
        </p>
        {session.paymentStatus === "Paid" && (
          <p data-testid="checkin-paid-summary" className="mt-2 font-semibold text-emerald-400">
            Paid ${Number(session.amountCharged || 0).toFixed(2)} {session.paymentChannel === "terminal" ? "on terminal" : `via ${session.paymentMethod}`}
            {session.paidDays && !session.openEnded ? ` for ${session.paidDays} day${session.paidDays > 1 ? "s" : ""}` : ""}
            {session.openEnded ? " for day 1 · open-ended, auto-charges every 25h" : ""}
            {session.cardLast4 ? ` · ${session.cardBrand || "Card"} ****${session.cardLast4}` : ""}
            {session.approvalCode ? ` · Approval ${session.approvalCode}` : ""}
          </p>
        )}
        <p className="mt-2 text-xs text-slate-500">Ticket number was texted to the driver with their renew link.</p>
      </div>
      <Button
        data-testid="checkin-confirmation-done"
        onClick={onClose}
        className="h-12 w-full bg-[#A0148C] font-bold hover:bg-[#80106F]"
      >
        Done
      </Button>
    </div>
  );
}
